import React from 'react';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Translation } from 'react-i18next';
import { object } from 'prop-types';
import VisaDetails from './VisaDetails';
import PersonalDetails from './PersonalDetails';
import PassportDetails from './PassportDetails';
import ContactDetails from './ContactDetails';
import Payment from './Payment';
import FormText from '../../forms/components/FormText';
import FormDatePicker from '../../forms/components/FormDatePicker';

const styles = (theme) => ({
  mainForm: {
    flexGrow: 1,
    padding: theme.spacing(2),
    borderWidth: 2,
    marginTop: theme.spacing(10),
  },
  applicationInfo: {
    marginBottom: theme.spacing(4),
  },
  buttonBackTo: {
    backgroundColor: '#0280CA',
    color: '#ffffff',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  buttonNext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
    background: '#357a38',
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  buttonLeftContainer: {
    display: 'flex',
  },
  buttonRightContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  buttonBack: {
    backgroundColor: '#b22a00',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  field: {
    padding: theme.spacing(2),
  },
});

function PrintableForm(props) {
  const { classes, application, quote } = props;
  return (
    <Translation>
      {(t) => {
        return (
          <div>
            <Typography variant="h4" align="center" gutterBottom>
              {t('applicationSummaryTitle')}
            </Typography>
            <VisaDetails readOnly />
            <Grid container spacing={3}>
              <Grid item xs={6} className={classes.field}>
                <FormText
                  label={t('yourApplicationID')}
                  value={application.ian}
                  readOnly
                />
              </Grid>
              <Grid item xs={6} className={classes.field}>
                <FormText
                  label={t('shortcode')}
                  value={application.shortCode}
                  readOnly
                />
              </Grid>
              <Grid item xs={6} className={classes.field}>
                <FormText
                  label={t('submitter')}
                  value={application.submittedByFullName}
                  readOnly
                />
              </Grid>
            </Grid>
            <PersonalDetails readOnly />
            <div className="break" />
            <PassportDetails readOnly />
            <div className="break" />
            <ContactDetails readOnly />
            {application.feeAmount && (
              <Grid item xs={11}>
                <Payment readOnly quote={quote} />
                <Grid container spacing={3}>
                  <Grid item xs={6} className={classes.field}>
                    <FormText
                      label={t('payment_method')}
                      value={application.paymentMethodName}
                      readOnly
                    />
                  </Grid>
                  <Grid item xs={6} className={classes.field}>
                    <FormDatePicker
                      label={t('paidAt')}
                      value={moment(application.paymentPaidAt).format(
                        'YYYY-MM-DD'
                      )}
                      readOnly
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}
          </div>
        );
      }}
    </Translation>
  );
}

PrintableForm.propTypes = {
  classes: object.isRequired,
};

export default withStyles(styles)(PrintableForm);



// WEBPACK FOOTER //
// ./src/view/forms/Application/PrintableForm.js